import Toast from './Toast.vue'
import Vue from 'vue'

const ToastConstructor = Vue.extend(Toast)
const toastPlugin = {}
const instances = []
let initIndex = 0
let instance
let timer, visibleTimer
let showToast = false // 是否有Toast组件在显示
// 构建单个toast
function generateInstance(options) {
  if (showToast) {
    clearTimeout(timer)
    clearTimeout(visibleTimer)
    instance.visible = showToast = false
    document.body.removeChild(instance.$el)
  }
  // 挂载Toast组件
  instance = new ToastConstructor({
    data: options,
  }).$mount(document.createElement('div'))

  // 生成Toast组件标识
  const id = `toast_${initIndex++}`
  instance.id = id
  document.body.appendChild(instance.$el)
  instance.visible = showToast = true

  visibleTimer = setTimeout(() => {
    instance.visible = false
  }, options.duration - 600)

  timer = setTimeout(() => {
    showToast = false
    document.body.removeChild(instance.$el)
  }, options.duration)

  return instance
}

toastPlugin.install = function(Vue) {
  Vue.prototype.$toast = (text, duration = 3000) => {
    const instance = generateInstance({ text, duration })
    instances.push(instance)
  }
}

export default toastPlugin
